export default {"src":"/_next/static/media/DUPLICATE.bc0381bc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};